import React from "react";
import classes from "./styles/style.module.css";
import CustomButton from "../../components/CustomButton";
import RulesImg from "../../images/joftPooch/rulesImg.png";
import CustomModal from "../../components/ModalComonent";

export default function UpdateBanner({ show, link }) {
  const banner = (
    <div className="w-100">
      <img src={RulesImg} alt="awardIcon" className={classes.alertBanner} />
      <p className={classes.title}>دانلود به‌روز‌رسانی</p>
      <div className={classes.dialogContent}>
        <p className="text-center">برای به‌روز‌رسانی به نسخه جدید کلیک کنید</p>
        <div className="mt-4">
          <CustomButton
            text={"دانلود به‌روزرسانی"}
            color={"primary"}
            shadow={true}
            clickHandler={() => (window.location.href = link)}
          />
        </div>
      </div>
    </div>
  );

  return (
    <CustomModal
      open={show}
      closeHandler={() => {
        return;
      }}
      inputDialog={true}
      dialogContent={banner}
    />
  );
}
